<template>
  <div class="viewer-360"></div>
</template>

<script>
import * as Panolens from 'panolens'
import * as THREE from 'three'

Panolens.Viewer.prototype.getPosition = function () {
  var intersects, point, panoramaWorldPosition, outputPosition
  intersects = this.raycaster.intersectObject(this.panorama, true)

  if (intersects.length > 0) {
    point = intersects[0].point
    panoramaWorldPosition = this.panorama.getWorldPosition()

    // Panorama is scaled -1 on X axis
    outputPosition = new THREE.Vector3(
      -(point.x - panoramaWorldPosition.x).toFixed(2),
      (point.y - panoramaWorldPosition.y).toFixed(2),
      (point.z - panoramaWorldPosition.z).toFixed(2),
    )
  }

  return outputPosition
}

export default {
  watch: {
    data: 'init',
  },
  data() {
    return {
      viewer: null,
      autoRotate: true,
      panoramas: {},
      data: null,
    }
  },
  computed: {
    name() {
      return this.data
    },
  },
  methods: {
    init() {
      this.viewer = new Panolens.Viewer({
        container: this.$el,
        autoHideInfospot: false,
        output: 'console',
      })

      if (this.autoRotate) this.viewer.enableAutoRate()

      // Setup panos
      Object.entries(this.data).forEach(([room, value]) => {
        this.$set(this.panoramas, room, new Panolens.ImagePanorama(value.src))

        this.viewer.add(this.panoramas[room])

        this.panoramas[room].addEventListener('click', () => {
          console.log(this.viewer.getPosition())
        })
      })

      // Setup links
      Object.entries(this.data).forEach(([room, value]) => {
        if (!value.links) return
        value.links.forEach(link => {
          this.panoramas[room].link(this.panoramas[link.to], new THREE.Vector3(link.pos.x, link.pos.y, link.pos.z))
        })
      })
    },
  },
  created() {
    let params = new URLSearchParams(location.search)
    if (!params.has('data')) return

    try {
      this.data = JSON.parse(decodeURIComponent(params.get('data')))
      this.autoRotate = params.get('auto-rotate') !== 'false'
    } catch (err) {}
  },
}
</script>

<style lang="scss">
.viewer-360 {
  height: inherit;
  width: inherit;
}
</style>
